import { render, staticRenderFns } from "./data-import.vue?vue&type=template&id=082e27e4&scoped=true&"
import script from "./data-import.vue?vue&type=script&lang=ts&"
export * from "./data-import.vue?vue&type=script&lang=ts&"
import style0 from "./data-import.vue?vue&type=style&index=0&id=082e27e4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082e27e4",
  null
  
)

export default component.exports